module.exports = __webpack_public_path__ + "empty-state.79236ce0d831233ff7c8.png";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/demo.airtory.com-stage/src/assets/images/empty-state.png
// module id = ../../../../../src/assets/images/empty-state.png
// module chunks = main